import { RoleConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case RoleConstant.SET_ROLE:
      return { ...state, detail: payload };
    case RoleConstant.SET_ROLES:
      return { ...state, list: payload };
    default:
      return state;
  }
};
